import React from 'react';
import { MemberArtistRow, MemberArtistSection } from './MemberListSectionParts';

export default function MemberArtistSectionsBlock({
  decidedSections = [],
  undecidedList = [],
  isAllMemberPartScope = false,
  onArtistClick,
  avatarStyle,
  avatarInitial,
  sectionClassName,
  titleClassName,
  listClassName,
  rowClassName,
  avatarClassName,
  infoClassName,
  nameClassName,
  membershipClassName,
  badgesClassName,
  concertmasterBadgeClassName,
  chiefBadgeClassName,
  roleBadgeClassName,
  emptyClassName,
  emptyText = '参加メンバーがいません',
  undecidedTitleText = 'パート決定前',
  renderTrailing,
}) {
  return (
    <>
      {decidedSections.map((section) => (
        <MemberArtistSection
          key={section.id}
          section={section}
          onArtistClick={onArtistClick}
          avatarStyle={avatarStyle}
          avatarInitial={avatarInitial}
          sectionClassName={sectionClassName}
          titleClassName={titleClassName}
          listClassName={listClassName}
          rowClassName={rowClassName}
          avatarClassName={avatarClassName}
          infoClassName={infoClassName}
          nameClassName={nameClassName}
          membershipClassName={membershipClassName}
          badgesClassName={badgesClassName}
          concertmasterBadgeClassName={concertmasterBadgeClassName}
          chiefBadgeClassName={chiefBadgeClassName}
          roleBadgeClassName={roleBadgeClassName}
          showMembership
          showBadges={false}
          showRolesAsText
          includeCustomRoles
          renderTrailing={renderTrailing}
        />
      ))}

      {undecidedList.length > 0 ? (
        <section className={sectionClassName}>
          {!isAllMemberPartScope ? <h4 className={titleClassName}>{undecidedTitleText}</h4> : null}
          <ul className={listClassName}>
            {undecidedList.map((member) => (
              <MemberArtistRow
                key={member.id}
                member={member}
                onClick={onArtistClick}
                avatarStyle={avatarStyle}
                avatarInitial={avatarInitial}
                rowClassName={rowClassName}
                avatarClassName={avatarClassName}
                infoClassName={infoClassName}
                nameClassName={nameClassName}
                membershipClassName={membershipClassName}
                badgesClassName={badgesClassName}
                concertmasterBadgeClassName={concertmasterBadgeClassName}
                chiefBadgeClassName={chiefBadgeClassName}
                roleBadgeClassName={roleBadgeClassName}
                showMembership
                showBadges={false}
                showRolesAsText
                includeCustomRoles={false}
                renderTrailing={renderTrailing}
              />
            ))}
          </ul>
        </section>
      ) : null}

      {decidedSections.length === 0 && undecidedList.length === 0 ? (
        <div className={emptyClassName}>{emptyText}</div>
      ) : null}
    </>
  );
}
